import React, {useState} from 'react';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

function ContactDialog(props) {
  const [dialogState, setDialogState] = useState(false);

  const handleClickOpen = () => {
    setDialogState(true);
    props.formSubmit();
  };

  const handleClose = () => {
    setDialogState(false);
  };

    return (
      <div>
        {/* Button to trigger the opening of the dialog */}
        <button onClick={handleClickOpen} className="btn mx-auto  mb-4 btn-primary d-flex" >
                                    <div className="btn-text p-2  justify-content-center align-self-center mx-auto">SEND MESSAGE</div>
                                </button>
        {/* Dialog that is displayed if the state open is true */}
        <Dialog
          open={dialogState}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Message Sent"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your message has been sent! You should hear back from us soon.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
}

export default ContactDialog;
